import type { SupportWidgetTheme } from './types';

export const defaultTheme: SupportWidgetTheme = {
  bgPanel: '#1a1a2e',
  bgSurface: '#22223b',
  accentPrimary: '#4cc9f0',
  accentSecondary: '#7b2cbf',
  textPrimary: '#e0e0e0',
  textSecondary: '#9a9ab0',
  border: '#2d2d44',
  overlayBg: 'rgba(0, 0, 0, 0.7)',
  borderRadius: '8px',
  fontFamily:
    "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
};

/**
 * Merge user overrides with defaults and return a flat map of
 * CSS custom property declarations for `style` attributes.
 */
export function buildCssVars(
  overrides?: Partial<SupportWidgetTheme>,
): Record<string, string> {
  const merged: SupportWidgetTheme = { ...defaultTheme, ...overrides };
  return {
    '--sw-bg-panel': merged.bgPanel,
    '--sw-bg-surface': merged.bgSurface,
    '--sw-accent-primary': merged.accentPrimary,
    '--sw-accent-secondary': merged.accentSecondary,
    '--sw-text-primary': merged.textPrimary,
    '--sw-text-secondary': merged.textSecondary,
    '--sw-border': merged.border,
    '--sw-overlay-bg': merged.overlayBg,
    '--sw-border-radius': merged.borderRadius,
    '--sw-font-family': merged.fontFamily,
  };
}
